import React, { useContext, useState } from 'react';
import { gql, useMutation, useQuery } from '@apollo/client';
import { RemoteControlContext } from '../../ContextProvider';
import Loading from '../../components/Loading';
import { List, ListItem, ListItemText, Typography, Drawer, Container, CardActions, ListItemButton, Snackbar, Alert } from '@mui/material';
import LocationSearchingOutlinedIcon from '@mui/icons-material/LocationSearchingOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const GET_DEVICES = gql`
    query getDevices($org_id: Int!) {
        Organization(id: $org_id) {
            id
            Devices {
                id
                name
            }
        }
    }
`;

const SEND_COMMAND = gql`mutation sendCommand ($device_id: Int!, $command: String! $payload: JSON){
    notify_screen(device_id: $device_id, command: $command, payload: $payload) { successful message status  }
}`;

export default function Devices ({ open, onClose }) {
    const [errorIdentifying, setErrorIdentifying] = useState(false);
    const { currentOrg } = useContext(RemoteControlContext);
    const [sendCommand] = useMutation(SEND_COMMAND, { onError: () => setErrorIdentifying(true) });

    const { data, error, loading } = useQuery(GET_DEVICES, {
        fetchPolicy: 'cache-and-network',
        variables: {
            org_id: currentOrg.id
        }
    });

    const findDevice = ({ id, name }) => sendCommand({
        variables: {
            device_id: id,
            command: 'identify',
            payload: { name }
        }
    });

    if (loading) return <Loading />;
    if (error) return <Container><Typography>An error occurred, please try again later</Typography></Container>;

    const devices = data.Organization.Devices;

    return (
        <Drawer open={open} onClose={onClose} anchor='right'>
            <Container variant='drawer-header'>
                <ArrowBackIcon onClick={onClose} />
                <Typography variant='drawer-header'>Devices Menu</Typography>
            </Container>
            <List>
                {devices.length > 0
                ? devices.map((device) => (
                    <ListItem variant='devices' key={device.id}>
                        <ListItemButton variant='devices' onClick={() => findDevice(device)}>
                            <ListItemText variant='ellipsis'>
                                <Typography variant='ellipsis'>{device.name}</Typography>
                            </ListItemText>
                            <CardActions variant='live-event-card-actions'>
                                <LocationSearchingOutlinedIcon fontSize='small' />
                                <Typography variant='live-event-card-actions-caption'>
                                    Find Device
                                </Typography>
                            </CardActions>
                        </ListItemButton>
                    </ListItem>
                                ))
                : <Container><Typography>You don&apos;t have any devices!</Typography></Container>}
            </List>
            <Snackbar open={errorIdentifying} autoHideDuration={5000} onClose={() => setErrorIdentifying(false)}>
                <Alert severity='error'>Error identifying screen</Alert>
            </Snackbar>
        </Drawer>
    );
}
